/**
 * OMON-360 — the shift role a carer declared, on their Chase case.
 *
 * A self-declared role can't be verified, and the easy choice is the role
 * that owes least (Ed, 2026-09-28), so the office SEES each carer's claim.
 * The reconciler stamps it as `meta.shiftRole {code, declared}` when it
 * judges per person (ADR-0035 7d); `declared: false` means nothing was
 * chosen and primary applied (am.7b: unanswered = primary).
 */

export interface ShiftRole {
  code: "primary" | "secondary" | "relief" | "shadow";
  declared: boolean;
}

const WORDS: Record<ShiftRole["code"], string> = {
  primary: "primary",
  secondary: "second",
  relief: "relief",
  shadow: "shadowing",
};

/** "relief (chosen)" / "primary (not chosen)", or "" with nothing to show. */
export function roleLabel(role: ShiftRole | null | undefined): string {
  if (!role || !(role.code in WORDS)) return "";
  return `${WORDS[role.code]} (${role.declared ? "chosen" : "not chosen"})`;
}

/** The spot-check filter: a carer who chose a role other than primary. */
export function isOtherThanPrimary(role: ShiftRole | null | undefined): boolean {
  return Boolean(role && role.declared && role.code !== "primary");
}
